<div
	(mouseenter)="collapseOpenSidenav()"
	(mouseleave)="collapseCloseSidenav()"
	[class.collapsed]="collapsed()"
	[class.open]="collapsed() && collapsedOpen$ | async"
	class="sidenav flex flex-col">
	<!-- Search + chips: sticky, do not scroll with menu items -->
	<div class="sidenav-top-sticky">
		<div class="pt-3">
			<div class="vex-sidenav-search__inline-container">
				<div class="vex-sidenav-search" (click)="openQuickSearch()">
					<mat-icon class="vex-sidenav-search__icon">search</mat-icon>
					<span class="vex-sidenav-search__placeholder">Schnellsuche</span>
					<span class="flex-1"></span>
					<mat-icon
						class="vex-sidenav-search__info-icon"
						matTooltip="Suche nach Liegenschaftsnummer, Adresse oder Hausverwaltung. Ergebnis wird als Pin gesetzt."
						matTooltipPosition="right">
						info_outline
					</mat-icon>
				</div>
			</div>
		</div>

		<!-- Recent-Chips: Bar immer im DOM, kein @if-Wrapper (verhindert Sprung beim Signal-Update) -->
		<div class="sidenav-recent-bar" [class.sidenav-recent-bar--empty]="!pinService.recentRealEstates().length">
			<div class="sidenav-chips-scroll">
				@for (re of pinService.recentRealEstates().slice(-5); track re.id) {
					<button class="sidenav-recent-chip" type="button" (click)="pinRecent(re)" [matTooltip]="chipTooltip(re)" matTooltipPosition="below">
						{{ re.area }}/{{ re.number }}
					</button>
				}
			</div>
			@if (pinService.recentRealEstates().length > 0) {
				<div
					#recentExpandBtn
					class="shrink-0 flex items-center justify-center w-5 h-5 border-none rounded-full bg-white/[0.08] cursor-pointer p-0 transition-[background] duration-150 ease-out hover:bg-white/[0.15]"
					(mouseenter)="onRecentBtnEnter(recentExpandBtn)"
					(mouseleave)="onRecentBtnLeave()">
					<mat-icon class="!text-[14px] !w-[14px] !h-[14px] !leading-[14px] text-white/55">read_more</mat-icon>
				</div>
			}
		</div>
	</div>

	<vex-scrollbar class="flex-1 flex flex-col">
		<div class="vex-sidenav-content">
			<div>
				@for (item of items; track trackByRoute($index, item)) {
					<vex-sidenav-item [item]="item" [level]="0"></vex-sidenav-item>
				}
			</div>

			<div class="vex-sidenav-footer-items">
				@for (item of footerItems; track trackByRoute($index, item)) {
					<vex-sidenav-item [item]="item" [level]="0"></vex-sidenav-item>
				}
			</div>
		</div>
	</vex-scrollbar>

	<div class="vex-sidenav-image-footer">
		<div class="vex-sidenav-image-footer__card">
			<img
				src="assets/img/icons/araproducts/araWeb/araWeb_weiß_doppelZeile.svg"
				alt="araWeb Logo"
				draggable="false"
				class="vex-sidenav-image-footer__image" />
			<span class="vex-sidenav-image-footer__version">V{{ version }}</span>
		</div>
	</div>
</div>
